export default __webpack_public_path__ + "static/media/back.00575892.svg";